module.exports = __webpack_public_path__ + "static/media/mobile-menu.aba639b3.svg";